import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

Vue.use(Vuex)

const state = {

	settings: JSON.parse(localStorage.getItem('shiseido-settings')) || JSON.parse(sessionStorage.getItem('shiseido-settings')) || {},
	token: localStorage.getItem('shiseido-token') || sessionStorage.getItem('shiseido-token') || null,

	// db options
	options: {
		area: [],
		brand: [],
		country: [],
		distributionChannel: [],
		generalFloorPlan: [],
		groupeSpacePlan: [],
		projectStatus: [],
		speficifNeed: [],
		typeOfProjectLabel: [],
		typeOfStore: [],
		csrf_new_token: '',
	},

	optionsLoaded: false,

	// shiseido db of projects
	projects: {},
	indexes: [],
	projectsFile: ''
}

const store = new Vuex.Store({
	state,
	getters,
	actions,
	mutations
})

// hot reload
if (module.hot) {
	module.hot.accept([
		'./getters',
		'./actions',
		'./mutations'
	], () => {
		store.hotUpdate({
			getters: require('./getters'),
			actions: require('./actions'),
			mutations: require('./mutations')
		})
	})
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js